import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {CustomerLicense} from "../interface/customer-license";

@Injectable({
  providedIn: 'root'
})
export class CustomerLicenseService {

  private baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }

  get(id: number): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/customer/license/${id}`);
  }

  getCollection(): Observable<CustomerLicense[]>{
    return this.http.get<CustomerLicense[]>(`${this.baseUrl}/get/customer/licenses`);
  }

  delete(id: number): Observable<CustomerLicense>{
    return this.http.delete<CustomerLicense>(`${this.baseUrl}/delete/customer/license/` + id);
  }
}
